<template>
  <div class="p-grid">
    <div class="p-col-12">
      <br />
      

      <h4>List of Tasks & Events</h4>

      <Toolbar class="p-mb-4">
        <template slot="left">
          <Button
            label="New Task or Event"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="openNew"
          />
        </template>

        <template slot="right">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global']"
              placeholder="Global Search"
              style="margin-right: 0.5em"
              @input="updateSearch"
            />
          </span>
        </template>
      </Toolbar>

      <ActivityTable
        v-if="Array.isArray(activities)"
        :key="activitiesKey"
        :activities="activities"
        :loading="loading"
      />
    
      <!-- Activity Form -->
      <ActivityForm
        v-if="activityDialog"
        :key="activityFormKey"
        :activityForm="activityDialog"
        mode="auto"
        :activityToEdit="activity"
        :disabledArr="disabledArr"
        @close="activityDialog = false"
        @saved="savedActivity"
      />

    </div>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

import ActivityTable from './activitiesTable'
import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";

export default {
  components: {
    ActivityTable,
    ActivityForm
  },
  data: () => ({
    quotationService: new QuotationService(),
    filters: {},
    activityDialog: false,
    activityFormKey1: 0,
    activity: {},
    disabledArr: [],
    activitiesKey: 0,
    requesting: false
  }),
  computed: {
    loading() {
      if (this.activities && this.activities[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    },
    quotation() {
      return this.$store.getters['quotations/getQuoteForTabs']
    },
    activities() {
      return this.$store.getters['quotations/getQuoteActivitiesForTab']
    },
    activityFormKey: {
      set(val) {
        this.activityFormKey1++
      },
      get() {
        return 'activityForm' + this.activityFormKey1.toString()
      }
    }
  },
  created() {
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    activityDialog(val) {
      this.activityFormKey++
    },
    activities(val) {
      if (val && val[0]) {
        this.activitiesKey++
      }
    }
  },
  methods: {
    getQuotationActivities(quoteVerId) {
      this.requesting = true
      this.quotationService
        .getQuotationActivities(quoteVerId)
        .then(data => {
          this.requesting = false
          this.$store.dispatch('quotations/setQuoteActivitiesForTab', data)
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation activities",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationactivities/{quoteVerId}"'
          })
        })
    },
    savedActivity(activity) {
      
      this.activityDialog = false
      this.getQuotationActivities(this.quotation.quoteVerId)
    },
    openNew() {
      // 
      var quote = this.quotation
      
      this.activityDialog = true

      this.disabledArr = [
        'customer',
        'contact',
        'mbpBranch',
        'quote'
      ]

      this.activity.customer = quote.customer
      if (quote.customer.keyContact)
        this.activity.contact = quote.customer.keyContact
      this.activity.mbpBranch = quote.mbpBranch
      this.activity.quote = quote
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
      this.activitiesKey++
    }
  }
}
</script>

<style>

</style>